import React, {useEffect, useState} from 'react';
import styles from './content.module.scss';
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import FAQItem from "@/components/faq/item";

const FAQContent: React.FC<any> = () => {
    const [faqs, setFAQs] = useState<IFAQItem[] | null>(null);

    useEffect(() => {
        setFAQs([
            {
                question: "آیا امکان دانلود فایل ها پس از خرید وجود دارد؟",
                answer: "بله، شما میتوانید پس از خرید، همه فایل های پست که میتواند شامل تکست، بیت و یا ماکت باشد را دانلود نمایید."
            },
        ]);
    }, []);

    return (
        <div className={styles.faq}>
            <Container className={styles.services + ' py-5'}>
                <h2>سوالات پرتکرار</h2>
                {faqs?.map((faq, idx) => (
                    <FAQItem key={idx} show={!idx} faq={faq} />
                ))}
                <p>
                    لطفا در صورتی که پاسخ سوال خود را در اینجا پیدا نمی کنید، مسئله را از طریق صفحه
                    {' '}<Link to={"/contact"}>تماس با ما</Link>{' '}
                    در میان بگذارید.
                </p>
            </Container>
        </div>
    );
}

export default FAQContent;
